import CHECKED from "./checkd"; //验证规则
import $http from "../service/apiscopy"; //请求接口
import { HTTP_CODE } from "../service/axios_constants"; //请求返回状态
import { checkNullNoArr } from "../filters/filters";
/**
 * @class Vakudatir
 * @classdesc 所有表单验证
 * @constructor
 * @desc 不需要构造函数 直接使用类
 * @TODO 未处理IE6-8的兼容性
 */
export default class Vakudatir {
  constructor() {
    this.passPwd1; //记录新密码  用来验证确认密码是否与密码一致
    this.time = null; //防抖标记
    this.flag = false;
  }
  /**
   * @desc 验证密码
   */
  static validatePass(rule, value, callback) {
    if (value === "") {
      callback(new Error(" "));
    } else if (!CHECKED.checkPwd(value)) {
      callback(new Error("8-12位数字+字母+符号组合（区分大小写)"));
    } else {
      callback();
    }
    Vakudatir.passPwd1 = value;
  }
  /**
   * @desc 验证确认密码是否与密码一致
   */
  static validatePass2(rule, value, callback) {
    if (value === "") {
      callback(new Error(" "));
    } else if (value != Vakudatir.passPwd1) {
      callback(new Error("确认密码与密码不一致!"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证表单input是否为空 只提示红框 没有文字提示
   */
  static checkNull(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证表单时间段数组是否为空 只提示红框 没有文字提示
   */
  static checkArrayNull(rule, value, callback) {
    if (checkNullNoArr(value)) {
      callback(); // 编辑保险代理人
    } else if (value.length === 0) {
      callback(new Error(" ")); // 添加保险代理人
    } else {
      callback();
    }
  }

  /**
   * @desc 验证身份证号码是否符合规范
   */
  static validateCard(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkIdCard(value)) {
      callback(new Error("证件号格式错误"));
    } else {
      callback();
    }
  }

  /**
   * 添加子账号验证
   * */

  /**
   * @desc 验证账号格式是否符合,
   * @desc 验证账号是否已经存在
   */
  static validateAddEmailLogin(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkEmail(value) && !CHECKED.checkAccountNumberLength(value)) {
      callback(new Error("格式错误，请输入大于五位的数字或字母或邮箱"));
    } else {
      let parmes = {
        loginName: value
      };
      $http.postcheckChildTheLoginName(parmes).then(res => {
        if (res.statusCode == HTTP_CODE.suc) {
          callback();
        } else {
          callback(new Error("账号已被使用"));
        }
      });
    }
  }

  /**
   * @desc 邮箱验证
   */
  static validateEmail(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkEmail(value)) {
      callback(new Error("邮箱格式错误"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证手机号码格式是否符合,
   */
  static validatePhone(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkPhoneNumber(value)) {
      callback(new Error("手机号格式错误"));
    } else if (!CHECKED.checkIphoneLength(value)) {
      callback(new Error("手机号长度错误！"));
    } else {
      callback();
    }
  }

  /**
   * @desc 防抖函数
   */
  static debounce(fn, delay) {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(fn, delay); // 简化写法
    console.log(this.timer);
  }

  /**
   * @desc 验证用户昵称
   */
  static validateAddUserName(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入昵称"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证密码
   */
  static validateAddPassWord(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入密码"));
    } else if (!CHECKED.checkPwd(value)) {
      callback(new Error("8-12位数字+字母+符号组合（区分大小写)"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证税务登记号
   */
  static validateTaxRegistrationNo(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入税务登记号"));
    } else if (!CHECKED.checkTaxRegistrationNo(value)) {
      callback(new Error("请检查税务登记号是否正确"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证手机号码是否已被使用请求
   */
  static xhrCheckChildThePhone(value, callback) {
    let parmes = {
      phoneNo: value
    };
    $http.postcheckChildThePhone(parmes).then(res => {
      if (res.statusCode === HTTP_CODE.suc) {
        callback();
      } else {
        callback(new Error("手机号码已被使用"));
      }
    });
  }

  /**
   * @desc 验证输入是否只包含数字或字母
   */
  static ChineseEnglishCode(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入用户编号"));
    } else if (!CHECKED.checkChinseEnglish) {
      callback(new Error("请输入数字或字母"));
    } else {
      callback();
    }
  }

  /**
   * @desc 验证用户名称
   */
  static ChineseEnglishName(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入用户名称"));
    } else if (!CHECKED.checkChinseEnglish) {
      callback(new Error("请输入数字或字母"));
    } else {
      callback();
    }
  }
  /**
   * @desc 收款人姓名
   */
  static gatheringWorkName(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入收款人姓名"));
    } else {
      callback();
    }
  }
  /**
   * @desc 银行卡号校验
   */
  static vdtBankCard(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkBankCard(value)) {
      callback(new Error("银行卡格式错误"));
    } else {
      callback();
    }
  }

  /**
   * @desc 是否为正常的金额
   * */
  static vdtCheckPrice(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkTwoPoint(value)) {
      callback(new Error("最多支持2位小数"));
    } else {
      callback();
    }
  }

  /**
   * @desc 保留一位小数
   * */
  static vdtCheckOneDecimal(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkOnePoint(value)) {
      callback(new Error("最多支持1位小数"));
    } else {
      callback();
    }
  }

  /**
   * @desc 请输入数字
   * */
  static vdtCheckNum(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkNum(value)) {
      callback(new Error("请输入数字"));
    } else {
      callback();
    }
  }

  /**
   * @desc 手机验证码
   * */
  static verifyCodeCheck(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入验证码"));
    } else {
      callback();
    }
  }

  /**
   * @desc 请输入英文
   * */
  static vdtCheckChinese(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (CHECKED.checkChinese(value)) {
      callback(new Error(" "));
    } else {
      callback();
    }
  }

  /**
   * @desc 请输入数字
   * */
  static vdtCheckPriceToThousands(rule, value, callback) {
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkPriceToThousands(value)) {
      callback(new Error(" "));
    } else {
      callback();
    }
  }

  /**
   * @desc 字段长度
   * */
  static vdtCheckFieldLength(rule, value, callback) {
    console.log(!CHECKED.checkFieldLength(value));
    if (!value) {
      callback(new Error(" "));
    } else if (!CHECKED.checkFieldLength(value)) {
      callback(new Error("字段长度4-32位"));
    } else {
      callback();
    }
  }
}



// WEBPACK FOOTER //
// ./src/FormVerification/validator.js